<template>
  <div>
    <v-card-title primary-title class="headline mast-header" :style="bg">{{ title }}</v-card-title>
    <v-card-text>
      <div v-if="hasItem || badRequest">
        <v-form ref="form" @submit.prevent="clear">
          <div v-if="hasItem">
            <component :is="resultComponent" :item="item"></component>
          </div>
          <h3 v-else-if="badRequest" class="red--text">
            {{ errorMessage }}
          </h3>
          <div class="text-xs-right">
            <v-btn type="submit">return</v-btn>
          </div>
        </v-form>
      </div>
      <div v-else>
        <v-form ref="form" @submit.prevent="submit">
          <div v-if="confirm && code">
            <p>You will have received a confirmation code via SMS.</p>
            <p>Please enter this below</p>
            <edit-field
              label="Confirmation code" icon="phonelink_lock"
              key="confirm" v-model="confirmCode" autofocus="true"/>
          </div>
          <div v-else>
            <slot name="form">
              <edit-field
                label="Registration Number" icon="verified_user" v-model="key"/>
            </slot>
          </div>
          <div class="captcha-container">
            <vue-recaptcha
              @verify="verify" @expired="verify"
              :size="mobile ? 'compact' : 'normal'"
              sitekey="6LeV2EgUAAAAAN6ZXbNwDSDzM7A9rWexuX5LMk86"/>
            <v-btn type="submit" :disabled="!canSubmit">submit</v-btn>
          </div>
        </v-form>
      </div>
    </v-card-text>
  </div>
</template>

<script>
import MooringResults from '@/components/mooring-results'
import VesselResults from '@/components/vessel-results'
import LicenceResults from '@/components/licence-results'
import EditField from '@/components/edit-field'
import VueRecaptcha from 'vue-recaptcha'
import API from '@/api'
import bg from '@/assets/mast.png'

const getDefaults = () => ({
  captcha: undefined,
  confirmCode: '',
  key: '',
  code: '',
  sending: false,
  item: {},
  badRequest: false,
  errorMessage: `There was no ${this.type} matching your request.`
})

export default {
  name: 'checker-view',
  inject: ['$validator'],
  components: { EditField, VueRecaptcha, VesselResults, MooringResults, LicenceResults },
  computed: {
    mobile () {
      return this.$vuetify.breakpoint.name === 'xs'
    },
    verified () {
      return this.captcha !== undefined
    },
    hasItem () {
      return Object.keys(this.item).length > 0
    },
    canSubmit () {
      const verified = (this.confirm && this.code) || this.verified || process.env.NODE_ENV === 'development'
      return !this.sending && verified && !this.errors.any()
    },
    resultComponent () {
      return `${this.type}-results`
    },
    bg () {
      return `background-image:url(${bg})`
    }
  },
  props: {
    confirm: { type: Boolean, default: false },
    title: { type: String, required: true },
    type: { type: String, required: true },
    getData: { type: Function, required: false },
    permitCheck: { type: Boolean, default: false }
  },
  data: () => getDefaults(),
  methods: {
    clear () {
      Object.assign(this.$data, this.$options.data())
      this.$emit('cleared')
    },
    verify (response) {
      this.captcha = response
      this.$el.scrollIntoView()
    },
    async getItem () {
      let uri = `?endpoint=${this.type}s&rego=${this.key}`
      if (this.confirm) {
        uri += `&request_code=${this.code}&confirm_code=${this.confirmCode}`
      }
      const response = await API.get(uri, { permitCheck: this.permitCheck })
      this.item = response._success ? response : {}
      this.badRequest = !this.hasItem
      if (this.badRequest) {
        this.errorMessage = response.message
      }
    },
    async getCode () {
      const uri = `/${this.type}_requests/`
      const response = await API.post(uri, { data: this.getData() })
      this.code = response.request_code || ''
      this.key = response.key || ''
      this.confirmCode = ''
      this.badRequest = !this.code
    },
    async submit () {
      await this.$validator.validateAll()
      if (!this.canSubmit) return
      this.sending = true
      if (this.confirm && !this.code) {
        await this.getCode()
      } else {
        await this.getItem()
      }
      this.sending = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/checker.vue